const ERROR_MSGS = {
  "invalid-factor-id": "Mã khóa không hợp lệ!",
  "invalid-otp": "Mã OTP không hợp lệ!",
  "incorrect-otp": "Mã OTP không chính xác",
  "2fa-service-error": "Lỗi dịch vụ 2FA"
};

export default ERROR_MSGS;